import { PrivacyPolicyPage } from "@-/dev.improve.haniverse.routes.legal";

export default function PrivacyRoute() {
  return <PrivacyPolicyPage />;
}
